import { render, staticRenderFns } from "./BlockWithChecks.vue?vue&type=template&id=5af2c38e&"
import script from "./BlockWithChecks.vue?vue&type=script&lang=js&"
export * from "./BlockWithChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5af2c38e', component.options)
    } else {
      api.reload('5af2c38e', component.options)
    }
    module.hot.accept("./BlockWithChecks.vue?vue&type=template&id=5af2c38e&", function () {
      api.rerender('5af2c38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/BlockWithChecks.vue"
export default component.exports